module.exports = __webpack_public_path__ + "img/edit-square.43a7c546.svg";